import { VStack } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { call, colors, ColorIcon } from "goi_common";

function ParlorDetailConsult() {
  return (
    <VStack width="100%">
      <div style={{ marginTop: "60px" }} />
      <div className="subtitle3 gray900 font-center">
        이 장례식장에 대해 더 궁금하세요?
        <br />
        아니면 다른 궁금한 것이 있나요?
      </div>
      <div style={{ marginTop: "20px" }} />
      <div className="body3_r gray700 font-center">
        상담만 받고 서비스를 이용하지 않으셔도 좋습니다
        <br />
        저희는 그저 최고의 도움을 드리고 싶을 뿐입니다
      </div>
      <div style={{ marginTop: "32px" }} />
      <ConsultButton className="button2" onClick={() => call("1666-9784")}>
        <span style={{ marginBottom: "-2px" }}>장례전문가에게 문의하기</span>
        <div style={{ marginRight: "10px" }} />
        <ColorIcon name="arrow" color={colors.green250} width={9} />
      </ConsultButton>
      <div style={{ marginTop: "90px" }} />
    </VStack>
  );
}
const ConsultButton = styled.button`
  background: var(--black);
  display: flex;
  align-items: center;
  color: var(--green250);
  border-radius: 5px;
  padding: 21px 60px;
`;
export default ParlorDetailConsult;
